<span class="flex items-center w-full h-full">
    <button matButton (click)="onClick()" [matTooltip]="params.tooltip">{{ params.text }}</button>
</span>
